import React from 'react';

export type AbyssIcons =
  | 'add-image'
  | 'arrow-upward-rounded'
  | 'attach-media'
  | 'build'
  | 'calendar'
  | 'camera-search'
  | 'check'
  | 'circle-check'
  | 'close'
  | 'collapse'
  | 'comments'
  | 'crown'
  | 'cube'
  | 'cube-secondary'
  | 'date-picker'
  | 'delete'
  | 'description'
  | 'download'
  | 'download-thin'
  | 'expand'
  | 'fallback'
  | 'fallback-component-overview'
  | 'file-download-line'
  | 'file-download-line-secondary'
  | 'file-upload-line'
  | 'gear'
  | 'image'
  | 'image-filled'
  | 'long-back'
  | 'media'
  | 'notification'
  | 'pdf-upload'
  | 'position'
  | 'resize'
  | 'rotate-ccw'
  | 'rotate-cw'
  | 'rotate-cw-filled'
  | 'retry'
  | 'send'
  | 'screenshot'
  | 'spreadsheet'
  | 'status'
  | 'search'
  | 'search-simple'
  | 'status-secondary'
  | 'table'
  | 'task'
  | 'task-secondary'
  | 'undo'
  | 'unknown'
  | 'verify-doc'
  | 'versions'
  | 'version-day'
  | 'version-item'
  | 'zoom-in'
  | 'zoom-out'
  | 'refresh-right-square'
  | 'refresh-right-square-disabled'
  | 'sorting'
  | 'play';

interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
  iconName: AbyssIcons | string;
  pointer?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

const getSizeValue = (size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'): string => {
  switch (size) {
    case 'xs':
      return '1rem';
    case 'sm':
      return '1.2rem';
    case 'md':
      return '1.6rem';
    case 'lg':
      return '2rem';
    case 'xl':
      return '2.4rem';
    case '2xl':
      return '3rem';
    default:
      return size ? '1.6rem' : '2.1rem';
  }
};

export const AbyssIcon: React.FC<IconProps> = ({
  style = {},
  iconName,
  pointer,
  size,
  ...rest
}) => {
  return (
    <img
      data-testid={`${iconName}-icon`}
      src={`/assets/icons/${iconName}-icon.svg`}
      alt={`${iconName} icon`}
      style={{
        height: getSizeValue(size),
        ...style,
        ...(pointer ? { cursor: 'pointer' } : {}),
      }}
      {...rest}
    />
  );
};
